import React from "react";
import "@/styles/Layout.scss";
import { getUser } from "@/hooks/useLocalStorage";
import ToggleAgent from "@/components/ToggleRole";

function Home() {
  const user = getUser();

  if (user.role === "admin") {
    window.location.href = "admin";
  }

  return (
    <div className="sectionWrapper">
      <div className="welcome-message p-6 flex flex-col">
        <h2 className="text-lg font-semibold mb-3">
          Hi, {user.name}! Welcome to JP Associates
        </h2>
        <p className="text-muted text-base leading-loose">
          We're excited to have you join the JP Associates community. We're
          dedicated to empowering you and providing you with the tools and
          support you need to succeed.
        </p>
        <ul className="list-disc mt-4 ml-5 space-y-2 text-muted">
          <li>Intuitive and user-friendly interface.</li>
          <li>Dedicated support team ready to assist you.</li>
          <li>Growing marketplace with a wide range of opportunities.</li>
        </ul>
        <p className="text-green text-center mt-6">
          Let's work together to achieve your goals. Welcome to the JP
          Associates family!
        </p>
      </div>
      {/* Handle Agents */}
      <ToggleAgent user={user} />
    </div>
  );
}

export default Home;
